import React from 'react';
import { Router, Route, Redirect, IndexRoute } from 'react-router';
import LoginApp from '../LoginApp';
import RequestPasswordResetApp from '../RequestPasswordResetApp';
import RequestPasswordResetSuccessApp from '../RequestPasswordResetSuccessApp';
import UnsupportedBrowserApp from '../UnsupportedBrowserApp';
import ChangeEmailSuccessApp from '../ChangeEmailSuccessApp';
import ChangeEmailFailedApp from '../ChangeEmailFailedApp';
import ChangePasswordApp from '../ChangePasswordApp';
import ActivateAccountDuplicateApp from '../ActivateAccountDuplicateApp';
import CenteredFormLayout from '../layouts/CenteredFormLayout';
import UnknownUserApp from '../UnknownUserApp';
import BrowserDetector from '../utils/BrowserDetector';

export const paths = {
	APP_ROOT: '/',
	UNSUPPORTED_BROWSER: '/unsupportedbrowser',
	RESET_PASSWORD: '/resetpassword',
	RESET_PASSWORD_SUCCESS: '/resetpassword/success',
	CHANGE_EMAIL_SUCCESS: '/changeemail/success',
	CHANGE_EMAIL_FAILED: '/changeemail/failed',
	CHANGE_PASSWORD: '/changepassword/:nonce',
	ACTIVATE_ACCOUNT_DUPLICATE: '/activation/duplicate',
	UNKNOWN_USER: '/unknownuser',
};

const handleUnsupportedBrowser = (nextState, replace) => {
	const browserDetector = new BrowserDetector();
	const browserSupported = browserDetector.isSupported();

	console.log(browserSupported);

	if (nextState.location.pathname !== paths.UNSUPPORTED_BROWSER && !browserSupported) {
		replace({
			pathname: paths.UNSUPPORTED_BROWSER,
		});
	}
};

const handleKeepingVariantQueryParamOnChange = (prevState, nextState, replace) => {
	if (prevState.location.query.variant && !nextState.location.query.variant) {
		replace({
			...nextState.location,
			query: {
				...nextState.location.query,
				variant: prevState.location.query.variant,
			},
		});
	}
};

export default function getRoutes(history) {
	return (
		<Router history={history}>
			<Route
				path={paths.APP_ROOT}
				component={CenteredFormLayout}
				onEnter={handleUnsupportedBrowser}
				onChange={handleKeepingVariantQueryParamOnChange}
			>
				<IndexRoute
					component={LoginApp}
				/>
				<Route
					path={paths.RESET_PASSWORD}
					component={RequestPasswordResetApp}
				/>
				<Route
					path={paths.RESET_PASSWORD_SUCCESS}
					component={RequestPasswordResetSuccessApp}
				/>
				<Route
					path={paths.UNSUPPORTED_BROWSER}
					component={UnsupportedBrowserApp}
				/>
				<Route
					path={paths.CHANGE_PASSWORD}
					component={ChangePasswordApp}
				/>
				<Route
					path={paths.CHANGE_EMAIL_SUCCESS}
					component={ChangeEmailSuccessApp}
				/>
				<Route
					path={paths.CHANGE_EMAIL_FAILED}
					component={ChangeEmailFailedApp}
				/>
				<Route
					path={paths.ACTIVATE_ACCOUNT_DUPLICATE}
					component={ActivateAccountDuplicateApp}
				/>
				<Route
					path={paths.UNKNOWN_USER}
					component={UnknownUserApp}
				/>
			</Route>
			<Redirect from={'*'} to={'/'} />
		</Router>
	);
}



// WEBPACK FOOTER //
// ./src/routes/index.js